//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    props: ['inapplicant', 'inunit'],
    data: function data() {
        return {
            applicant: this.inapplicant,
            unit: this.inunit,
            lease: {},
            loading: false,
            error: null,
            success: false,
            renters_insurance: {},
            parkingcarportgarage: 0,
            trash_utility: 0,
            pest_control: 0,
            water_utility: 0,
            rentalInsuranceOptions: []
        };
    },

    watch: {
        inapplicant: function inapplicant(newData, oldData) {

            this.applicant = newData;
            this.lease = newData.leases ? newData.leases[0] : {};
        },
        inunit: function inunit(newData, oldData) {

            this.unit = newData;
        }
    },
    created: function created() {
        Event.$on('applicant-convert-to-resident', this.applicantConvertToResident);
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('applicant-convert-to-resident');
    },
    mounted: function mounted() {
        var $el = this;
        Event.$on('applicant-convert-to-resident', function () {
            $el.$children[0].$data.showSmallModal = true;

            window.axios.get('/prototype/property/rental-insurance').then(function (response) {
                if (response) {

                    $el.rentalInsuranceOptions = response.data;

                    var output = response.data.map(function (r) {
                        return {
                            label: r.title + ' ~ ' + r.amount,
                            value: r.id
                        };
                    });

                    $el.rentalInsuranceOptions = output;
                }
            });
        });

        Event.$on('applicant-convert-to-resident-goodbye', function () {
            $el.$children[0].$data.showSmallModal = false;
        });
    },

    methods: {
        applicantConvertToResident: function applicantConvertToResident() {
            var $el = this;
            $el.$children[0].$data.showSmallModal = true;

            window.axios.get('/prototype/property/rental-insurance').then(function (response) {
                if (response) {

                    $el.rentalInsuranceOptions = response.data;

                    var output = response.data.map(function (r) {
                        return {
                            label: r.title + ' ~ ' + r.amount,
                            value: r.id
                        };
                    });
                    $el.rentalInsuranceOptions = output;
                }
            });
        },
        convert: function convert() {

            var self = this;

            var sendData = {
                applicant_id: this.applicant.id,
                lease_expiration_date: this.lease_expiration_date,
                renters_insurance: this.renters_insurance.value,
                parkingcarportgarage: this.parkingcarportgarage,
                trash_utility: this.trash_utility,
                pest_control: this.pest_control,
                water_utility: this.water_utility
            };

            window.axios.post('/prototype/person/applicants/convert-to-resident', sendData).then(function (response) {

                window.location.href = '/prototype/person/residents';

                Event.$emit('applicant-convert-to-resident-goodbye');
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/applicants/ApplicantConvertToResident.vue
// module id = Hc70
// module chunks = 0 1